import axios from "axios";

import { SERVER_URL } from "../constants";

export const post = async (endpoint, headers, body) => {
  let url = endpoint;
  if (!endpoint.startsWith("http")) {
    url = `${SERVER_URL}/api${endpoint}`;
  }

  return axios
    .post(url, body, {
      headers,
      withCredentials: true,
      validateStatus: () => true,
    })
    .then((res) => {
      return res;
    });
};

export const patch = async (endpoint, headers, body) => {
  return axios
    .patch(`${process.env.REACT_APP_SERVER_URL}/api${endpoint}`, body, {
      headers,
      validateStatus: () => true,
    })
    .then((res) => {
      switch (res.status) {
        case 200:
          return res.data;
        default:
          return res.data.message;
      }
    });
};

export const deleteReq = async (endpoint, headers, body) => {
  return axios
    .delete(`${SERVER_URL}/api${endpoint}`, {
      headers,
      data: body,
      validateStatus: () => true,
    })
    .then((res) => {
      switch (res.status) {
        case 200:
          return res.data;
        default:
          return res.data.message;
      }
    });
};

export const get = async (endpoint, headers, body = {}) => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api${endpoint}`, {
      headers,
      withCredentials: true,
      validateStatus: () => true,
      params: body,
    })
    .then((res) => {
      switch (res.status) {
        case 200:
          return res.data;
        case 201:
          return res.data;
        default:
          return res.data.message;
      }
    })
    .catch((err) => {
      throw new Error(err.message);
    });
};
